import { createLogger, format, transports } from 'winston';

const util = require('util');

/**
 * Wrap createLogger to provide uniform options
 */
export function createMyLogger() {
  const logger = createLogger({
    levels: {
      error: 0,
      warn: 1,
      info: 2,
      http: 3,
      verbose: 4,
      debug: 5,
      trace: 6,
    },
    format: format.combine(
      format.errors({ stack: true }),
      format.splat(),
      format.json(),
    ),
    transports: [
      new transports.Console({
        name: 'console',
        // remove from here due to it's override of top-level
        // level: process.env.LOG_LEVEL || 'error',
      }),
    ],
  });

  // set the top-level based log level
  logger.level = process.env.LOG_LEVEL || 'error';

  /**
   * Function to format printf style message
   * @params {string} fmt - printf style format string
   * @params {Array} args - the rest of the arguments
   * @returns {string} formatted message
   */
  logger.fmt = function fmt(frmt, ...args) {
    const opts = { showHidden: false, depth: null, compact: true, maxArrayLength: Infinity, breakLength: Infinity };
    return util.formatWithOptions(opts, frmt, ...args);
  };

  /**
   * Set the logging level on the main logger object
   * (removed from first transport above to allow this control)
   * @params {string} level - level to set
   */
  logger.setLogLevel = function setLogLevel(level) {
    logger.level = level || 'error';
    // logger.transports[0].level = level || 'error';
  };
  return logger;
}

// /**
//  * export a singleton of the class instance
//  * @type {winston.Logger}
//  */
// export let logger = createMyLogger();
